import { Module, ActionContext } from 'vuex';
import { ajax } from '@/util/ajax';
import { subjectModule as subject } from '@/store/courseware/subjectModule';
import { catalogModule as catalog } from '@/store/courseware/catalogModule';
import { pptModule as ppt } from '@/store/courseware/pptModule';
import { chapterVideoModule as chapterVideo } from '@/store/courseware/chapterVideoModule';
import { specimenVideoModule as specimenVideo } from '@/store/courseware/specimenVideoModule';

const URL = {
  VERSION_LIST: '/dh-datamaint/version/listAll',
  SUBMIT_VERSION: '/dh-datamaint/version/submit',
  VERSION_LIST_SELF: '/dh-datamaint/version/listSelf'
};

class CoursewareModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {
    async getVersionList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.VERSION_LIST, { params: payload.data });
    },

    async getVersionListSelf(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.VERSION_LIST_SELF, { params: payload.data });
    },

    async submitVersion(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.SUBMIT_VERSION, payload.data);
    }
  };

  modules = {
    subject,
    catalog,
    ppt,
    chapterVideo,
    specimenVideo
  };
}

export const coursewareModule = new CoursewareModule();
